<section class="information-panel">
  <h2 *ngIf="data?.title?.value" class="information-panel__title" #titleEl>{{ data.title.value }}</h2>
  <h3 *ngIf="data?.title?.value" class="information-panel__subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>
  <div class="information-panel__content" #contentEl>
    <div *ngFor="let item of data.items.value" class="information-panel__cards">
      <app-information-panel-item [item]="item"></app-information-panel-item>
    </div>
  </div>
</section>
